import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import styled from 'styled-components';
import dayjs, { Dayjs } from 'dayjs';
import { TextField } from '@mui/material';
import { useState } from 'react';

const CustomStyleDatePicker = styled(DatePicker)`
  & label {
    color: #888;
  }
  & label.Mui-focused {
    color: #888;
  }
  & .notchedOutline {
    border-color: #888;
  }
  & .MuiOutlinedInput-root {
    color: #333;
    & fieldset {
      border-color: #888;
    }
    &.Mui-focused fieldset {
      border-color: #888;
    }
    &:hover fieldset {
      border-color: #888;
    }
  }
`;

export default function CustomDatePicker({
  label,
  size,
  onChange,
  defaultValue,
}: { label: string; size?: 'medium' | 'small'; onChange: any; defaultValue?: Dayjs }) {
  const handleChange = (value: Dayjs) => {
    onChange && onChange(value);
  };

  const now = dayjs();
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <CustomStyleDatePicker
        sx={{ svg: { color: '#888' } }}
        format={'YYYY-MM-DD'}
        slotProps={{
          field: { clearable: true },
          calendarHeader: { format: 'YYYY-MM' },
          textField: { size: size ? size : 'medium', label, slotProps: { inputLabel: { shrink: true } } },
        }}
        onChange={handleChange}
        defaultValue={defaultValue}
      />
    </LocalizationProvider>
  );
}
